<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_company_information") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <h5 style="color: #724c80" class="font-weight-bold">
            {{ $t("PLACEHOLDERS.summaryData") }}
          </h5>
          <!-- Start:: Image Upload Input -->
          <div class="preview-container text-center my-3">
            <h6 style="color: #724c80" v-if="data.logo.path">
              {{ $t("PLACEHOLDERS.company_logo") }}
            </h6>
            <img
              v-if="data.logo.path"
              col="12"
              :src="data.logo.path"
              :alt="$t('PLACEHOLDERS.company_logo')"
            />
          </div>
          <!-- End:: Image Upload Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.company_name')"
            v-model.trim="data.name"
            disabled
          />
          <!-- End:: Name Input -->
          <!-- Start:: Name Input -->
          <base-input
            col="12"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.company_overview')"
            v-model.trim="data.about_company"
            disabled
          />
          <!-- End:: Name Input -->

          <!-- Start:: Phone Input -->
          <base-input
            ref="phoneInput"
            col="6"
            type="tel"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.mobile"
            disabled
          />
          <!-- End:: mobile Input -->

          <!-- Start:: Email Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            disabled
          />
          <!-- End:: Email Input -->

          <base-select-input
            col="6"
            :optionsList="areas"
            :placeholder="$t('PLACEHOLDERS.ar_or_city')"
            v-model="data.area_id"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :optionsList="areas"
            :placeholder="$t('PLACEHOLDERS.country')"
            value="المملكة العربية السعودية"
            disabled
          />
          <MapComponent :lat="latitude" :lng="longitude" />

          <base-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.subscribe_date')"
            v-model.trim="data.request_date"
            disabled
          />

          <div class="input_wrapper switch_wrapper col-lg-6 my-5">
            <v-switch
              color="green"
              :label="
                data.is_active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.is_active"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Confirm Password Input -->
          <h5 style="color: #724c80" class="font-weight-bold mt-5">
            {{ $t("PLACEHOLDERS.about_company") }}
          </h5>

          <base-select-input
            col="6"
            :optionsList="fields"
            :placeholder="$t('PLACEHOLDERS.company_field')"
            v-model="data.field_id"
            multiple
            disabled
          />

          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.company_size')"
            v-model.number="data.company_size"
            disabled
          />

          <!-- Start:: Deactivate Switch Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.company_url')"
            v-model.trim="data.company_url"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.rating')"
            v-model.trim="data.rating"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.counts_ads')"
            v-model.trim="data.counts_ads"
            disabled
          />

          <!-- Start:: Submit Button Wrapper -->

          <!-- Start:: date Input -->
          <base-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.found_date')"
            v-model.trim="data.found_date"
            disabled
          />
          <!-- End:: date Input -->

          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.company_description')"
            v-model.trim="data.company_description"
            disabled
          />

          <h6 style="color: #724c80" v-if="data.commercial_register">
            {{ $t("PLACEHOLDERS.commercial_register") }}
          </h6>
          <div class="col-12">
            <a
              :href="data.commercial_register"
              target="_blank"
              v-if="data.commercial_register"
            >
              <i class="fas fa-eye" style="color: #724c80; font-size: 20px"></i>
            </a>
          </div>
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MapComponent from "../../../components/general/MapComponent.vue";

export default {
  name: "Show Company",

  props: {
    id: {
      type: String,
      required: true,
    },
  },
  components: { MapComponent },
  data() {
    return {
      latitude: 24.7136,
      longitude: 46.6753,

      data: {
        logo: {
          path: null,
          file: null,
        },
        have_experience: null,
        name: null,
        about_company: null,
        email: null,
        mobile: null,
        birthday: null,
        area_id: null,
        password: null,
        password_confirmation: null,
        company_size: null,
        company_url: "",
        rating: null,
        counts_ads: null,
        found_date: null,
        is_active: null,
        field_id: [],
        commercial_regiser: null,
        experiences: [
          {
            company_name: null,
            years: null,
            from_date: null,
            to_date: null,
          },
        ],
      },
      areas: [],
      fields: [],
    };
  },

  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      allRoles: "ApiGetsModule/allRoles",
    }),
    // End:: Vuex Getters
    expStatus() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.yes"),
          value: "yes",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.no"),
          value: "no",
        },
      ];
    },
  },

  methods: {
    // Start:: Vuex Actions
    ...mapActions({
      getRoles: "ApiGetsModule/getRoles",
    }),
    // End:: Vuex Actions
    addRow() {
      this.data?.experiences.push({
        company_name: null,
        years: null,
        from_date: null,
        to_date: null,
      });
    },

    removeRow(index) {
      this.data?.experiences.splice(index, 1);
    },
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.logo = selectedImage;
    },
    selectcommercial_regiser(selectedImage) {
      this.data.commercial_regiser = selectedImage;
    },
    // End:: Select Upload Image

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    async getAreas() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `areas?page=0&limit=0&is_active=1`,
        });
        this.areas = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    async getFields() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `company-fields`,
        });
        this.fields = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    async getDataToShow() {
      console.log("has");
      try {
        let res = await this.$axios({
          method: "GET",
          url: `companies/${this.id}`,
        });
        this.data.logo.path = res.data.data.Company?.logo;
        this.data.name = res.data.data.Company?.name;
        this.data.email = res.data.data.Company?.email;
        this.data.mobile = res.data.data.Company?.mobile;
        this.data.company_size = res.data.data.Company?.company_size;
        this.data.is_active = res.data.data.Company?.is_active;
        this.data.found_date = res.data.data.Company?.foundation_date;
        this.data.lastVisit = res.data.data.Company?.last_logged;
        this.data.field_id = res.data.data.Company?.fields;
        this.data.area_id = res.data.data.Company?.area;
        this.data.about_company = res.data.data.Company?.about_company;
        this.data.company_description = res.data.data.Company?.description;
        this.data.request_date = res.data.data.Company?.request.request_date;

        this.data.commercial_register =
          res.data.data.Company?.commercialRegister;

        this.latitude = res.data.data.Company.latLng[0];
        this.longitude = res.data.data.Company.latLng[0];

        this.data.company_url = res.data.data.Company?.website;
        this.data.rating = res.data.data.Company?.rating.rate;
        this.data.counts_ads = res.data.data.Company?.count_ads_published;

        console.log(this.data.commercial_regiser);
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  async created() {
    // Start:: Fire Methods
    // End:: Fire Methods
    this.getFields();
    this.getAreas();
    this.getDataToShow();
    this.$nextTick(() => {
      this.data.mobile = "";
    });
  },
};
</script>
